export default __webpack_public_path__ + "static/media/total-cities.98076d52.png";